import i18n from '@/lang/i18n'
import { StrictNullable } from '@/shared/types/app.types'
import { uniqueId } from 'lodash'
import { store } from '@/store/store'

export enum ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum {
    CENTER = 'center',
    INSURER = 'insurer',
    PETITIONER = 'petitioner'
}

export enum ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum {
    IN = 'IN',
    DISTINCT = 'DISTINCT',
}

export interface ConfigurationLocalAccountingBillableClientsModalRulesItem {
    id: number
    text: string
}

export interface ConfigurationLocalAccountingBillableClientsModalRulesAssociation{
    id: ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum
    text: string
}
export const configurationLocalAccountingBillableClientsModalRulesCentersAssociation =
    (): ConfigurationLocalAccountingBillableClientsModalRulesAssociation => ({
        id: ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.CENTER,
        text: i18n.tc('configuration.modal.client.center', 2)
    })
export const configurationLocalAccountingBillableClientsModalRulesInsurersAssociation =
    (): ConfigurationLocalAccountingBillableClientsModalRulesAssociation => ({
        id: ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.INSURER,
        text: i18n.tc('configuration.modal.client.insurer', 2)
    })
export const configurationLocalAccountingBillableClientsModalRulesPetitionersAssociation =
    (): ConfigurationLocalAccountingBillableClientsModalRulesAssociation => ({
        id: ConfigurationLocalAccountingBillableClientsModalRulesAssociationTypeEnum.PETITIONER,
        text: i18n.tc('configuration.modal.client.professional', 2)
    })
export const configurationLocalAccountingBillableClientsModalRulesAllowedAssociations =
    (): ConfigurationLocalAccountingBillableClientsModalRulesAssociation[] => [
        configurationLocalAccountingBillableClientsModalRulesCentersAssociation(),
        configurationLocalAccountingBillableClientsModalRulesInsurersAssociation(),
        configurationLocalAccountingBillableClientsModalRulesPetitionersAssociation()
    ]

export interface ConfigurationLocalAccountingBillableClientsModalRulesCondition{
    id: ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum
    text: string
}
export const configurationLocalAccountingBillableClientsModalRulesAllowedConditions =
    (): ConfigurationLocalAccountingBillableClientsModalRulesCondition[] => [
        {
            id: ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum.IN,
            text: i18n.tc('configuration.modal.client.equal')
        },
        {
            id: ConfigurationLocalAccountingBillableClientsModalRulesConditionTypeEnum.DISTINCT,
            text: i18n.tc('configuration.modal.client.different')
        }
    ]

export interface ConfigurationLocalAccountingBillableClientsModalRulesAssociations{
    selected: ConfigurationLocalAccountingBillableClientsModalRulesAssociation
    list: ConfigurationLocalAccountingBillableClientsModalRulesAssociation[]
}

export interface ConfigurationLocalAccountingBillableClientsModalRulesConditions {
    selected: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesCondition>
    list: ConfigurationLocalAccountingBillableClientsModalRulesCondition[]
}

export interface ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab{
    type: ConfigurationLocalAccountingBillableClientsModalRulesAssociation
    condition: StrictNullable<ConfigurationLocalAccountingBillableClientsModalRulesCondition>
    ids: ConfigurationLocalAccountingBillableClientsModalRulesItem[]
    comboLoader: Function
}

export interface ConfigurationLocalAccountingBillableClientsModalRulesRuleTab {
    id: StrictNullable<number>
    itemId: string
    list: ConfigurationLocalAccountingBillableClientsModalRulesRuleItemTab[]
}
export const initialConfigurationLocalAccountingBillableClientsModalRulesTab =
    (): ConfigurationLocalAccountingBillableClientsModalRulesRuleTab => ({
        id: null,
        itemId: uniqueId(),
        list: []
    })

export interface ConfigurationLocalAccountingBillableClientsModalRulesState {
    activeTab: number
    laboratoryId: number
    allowedAssociations: ConfigurationLocalAccountingBillableClientsModalRulesAssociations
    allowedConditions: ConfigurationLocalAccountingBillableClientsModalRulesCondition[]
    listRules: ConfigurationLocalAccountingBillableClientsModalRulesRuleTab[]
    promise: StrictNullable<Promise<void>>
    centersCollection: ConfigurationLocalAccountingBillableClientsModalRulesItem[]
    insurersCollection: ConfigurationLocalAccountingBillableClientsModalRulesItem[]
    petitionersCollection: ConfigurationLocalAccountingBillableClientsModalRulesItem[]
}
export const initialConfigurationLocalAccountingBillableClientsModalRules =
    (): ConfigurationLocalAccountingBillableClientsModalRulesState => ({
        activeTab: 0,
        laboratoryId: store.getters.labId,
        allowedAssociations: {
            selected: configurationLocalAccountingBillableClientsModalRulesCentersAssociation(),
            list: configurationLocalAccountingBillableClientsModalRulesAllowedAssociations()
        },
        allowedConditions: configurationLocalAccountingBillableClientsModalRulesAllowedConditions(),
        listRules: [initialConfigurationLocalAccountingBillableClientsModalRulesTab()],
        promise: null,
        centersCollection: [],
        insurersCollection: [],
        petitionersCollection: []
    })
